import { Link } from 'react-router-dom';
import { Alert, Button } from '@mui/material';

// Why LCRR may look thin or empty - never leave a blank page unexplained (expenseNote from lcrr_dashboard.controller.js):
//   none   = no marketing expense has been entered for the month, so no lead cost can be worked out at all
//   unused = some expense is for a category that has no leads created in the month, so there was nothing to spread it over
const money = (n) => `₹${Number(n).toLocaleString('en-IN')}`;

// `canSet` comes from the page (it already knows what this person may configure), so the note asks the server for nothing.
const ExpenseNote = ({ note, month, canSet = false }) => {
  if (!note) return null;
  const label = month.format('MMMM YYYY');
  const message = note.reason === 'none'
    ? `No marketing expense has been entered for ${label}, so no lead cost can be worked out and LCRR can't be calculated for anyone.`
    : note.reason === 'unused'
      ? `${money(note.amount)} of ${label}'s marketing expense is for ${note.categories.join(', ')} - no lead of ${note.categories.length === 1 ? 'that category was' : 'those categories were'} created in ${label}, so there was nothing to spread it over and it was not used.`
      : null;
  if (!message) return null;
  return (
    <Alert
      severity={note.reason === 'none' ? 'warning' : 'info'}
      sx={{ mb: 2, alignItems: 'center' }}
      action={canSet ? <Button component={Link} to="/dashboard/warning-dashboard/marketing-expense" color="inherit" size="small">Marketing Expense</Button> : undefined}
    >
      {message}
    </Alert>
  );
};

export default ExpenseNote;
